import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import axios from "@/libs/api.request";
import { jingxiaoshang } from "./api_url";
/**
 * 设备分销管理列表接口
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_distribution_list = function device_distribution_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.device_distribution_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 区域列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var area_list = function area_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 经销商列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_merchant_all = function get_merchant_all(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_merchant_all,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 分配经销商
 * @param data
 * @returns {*|{responseURL}}
 */

export var allocation_add = function allocation_add(data) {
  return axios.request({
    url: jingxiaoshang.allocation_add,
    data: data,
    method: "post"
  });
};
/**
 * 分配详情
 * @param data
 * @returns {*|{responseURL}}
 */

export var allocation_log = function allocation_log(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.allocation_log,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var allocation_del = function allocation_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.allocation_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取下载token
 * @param data
 * @returns {*|{responseURL}}
 */

export var getdownloadtoken = function getdownloadtoken(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.getdownloadtoken,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 下载
 * @param data
 * @returns {*|{responseURL}}
 */

export var downloadFile = function downloadFile(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.downloadFile,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设备详细信息列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var devicedetail_list = function devicedetail_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.devicedetail_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 启用禁用
 * @param data
 * @returns {*|{responseURL}}
 */

export var handle_fx_status = function handle_fx_status(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.handle_fx_status,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 申诉
 * @param data
 * @returns {*|{responseURL}}
 */

export var appeal = function appeal(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.appeal,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var did_del = function did_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.did_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增区域
 * @param data
 * @returns {*|{responseURL}}
 */

export var area_add = function area_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑区域
 * @param data
 * @returns {*|{responseURL}}
 */

export var area_update = function area_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除区域
 * @param data
 * @returns {*|{responseURL}}
 */

export var area_del = function area_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.area_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增经销商
 * @param data
 * @returns {*|{responseURL}}
 */

export var merchant_add = function merchant_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑经销商
 * @param data
 * @returns {*|{responseURL}}
 */

export var merchant_update = function merchant_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 经销商列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var merchant_list = function merchant_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除商户
 * @param data
 * @returns {*|{responseURL}}
 */

export var merchant_del = function merchant_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.merchant_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 转移
 * @param data
 * @returns {*|{responseURL}}
 */

export var transfer_merchant_parent = function transfer_merchant_parent(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.transfer_merchant_parent,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设备新增激活统计
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_increate_activation = function device_increate_activation(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.device_increate_activation,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设备累计上线统计
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_accumulate_online = function device_accumulate_online(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.device_accumulate_online,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 操作状态
 * @param data
 * @returns {*|{responseURL}}
 */

export var handle_state = function handle_state(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.handle_state,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 告警列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var alarm_list = function alarm_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.alarm_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 处理告警
 * @param data
 * @returns {*|{responseURL}}
 */

export var handle_alarm = function handle_alarm(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.handle_alarm,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 物联网用户列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var iotuser_list = function iotuser_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.iotuser_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 查看设备
 * @param data
 * @returns {*|{responseURL}}
 */

export var view_device = function view_device(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.view_device,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取分类
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_type = function get_type(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_type,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增字典
 * @param data
 * @returns {*|{responseURL}}
 */

export var dict_add = function dict_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 字典列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var dict_list = function dict_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设置默认
 * @param data
 * @returns {*|{responseURL}}
 */

export var set_default = function set_default(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.set_default,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑字典
 * @param data
 * @returns {*|{responseURL}}
 */

export var dict_update = function dict_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 历史记录
 * @param data
 * @returns {*|{responseURL}}
 */

export var history_log = function history_log(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.history_log,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除历史记录
 * @param data
 * @returns {*|{responseURL}}
 */

export var history_log_del = function history_log_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.history_log_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 首页统计
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_index_data = function get_index_data(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_index_data,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取设备信息
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_device_info = function get_device_info(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_device_info,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取设备信息
 * @param data
 * @returns {*|{responseURL}}
 */

export var dsgetconfigbyuser = function dsgetconfigbyuser(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dsgetconfigbyuser,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设置加热膜
 * @param data
 * @returns {*|{responseURL}}
 */

export var set_jrm = function set_jrm(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.set_jrm,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设置时区
 * @param data
 * @returns {*|{responseURL}}
 */

export var set_timezone = function set_timezone(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.set_timezone,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增计划
 * @param data
 * @returns {*|{responseURL}}
 */

export var dptimetaskadd = function dptimetaskadd(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetaskadd,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 计划列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var dptimetasklist = function dptimetasklist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetasklist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除计划
 * @param data
 * @returns {*|{responseURL}}
 */

export var dptimetaskdel = function dptimetaskdel(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetaskdel,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑计划
 * @param data
 * @returns {*|{responseURL}}
 */

export var dptimetaskedit = function dptimetaskedit(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dptimetaskedit,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取设备信息
 * @param data
 * @returns {*|{responseURL}}
 */

export var iotconfigset = function iotconfigset(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.iotconfigset,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 拉取一级，二级数据
 * @param data
 * @returns {*|{responseURL}}
 */

export var iotdatalastget = function iotdatalastget(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.iotdatalastget,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 下发命令
 * @param data
 * @returns {*|{responseURL}}
 */

export var web_issue_order = function web_issue_order(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.web_issue_order,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 检测固件新版本
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_firmware_info = function get_firmware_info(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_firmware_info,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 下发升级固件指令
 * @param data
 * @returns {*|{responseURL}}
 */

export var upup_firmware = function upup_firmware(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.upup_firmware,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除字典
 * @param data
 * @returns {*|{responseURL}}
 */

export var dict_del = function dict_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.dict_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //

/**
 * 取消分配
 * @param data
 * @returns {*|{responseURL}}
 */

export var quxiao_fenpei = function quxiao_fenpei(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.quxiao_fenpei,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //

/**
 * 获取token
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_downloadtoken = function get_downloadtoken(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_downloadtoken,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //

/**
 * 导出
 * @param data
 * @returns {*|{responseURL}}
 */

export var daochu = function daochu(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.daochu,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
}; //

/**
 * 导入
 * @param data
 * @returns {*|{responseURL}}
 */

export var daoru = function daoru(data) {
  var country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request({
    url: jingxiaoshang.daoru,
    data: data,
    method: "post"
  });
};
/**
 * 设置采样频率
 * @param data
 * @returns {*|{responseURL}}
 */

export var config_caiyang_pinglv = function config_caiyang_pinglv(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.config_caiyang_pinglv,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设置逆变器
 * @param data
 * @returns {*|{responseURL}}
 */

export var config_nibianqi = function config_nibianqi(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.config_nibianqi,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 轨迹信息设备列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var trajectory_did_list = function trajectory_did_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.trajectory_did_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取设备当前位置
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_now_lnglat = function get_now_lnglat(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_now_lnglat,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取容量趋势图
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_rl_trends = function get_rl_trends(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_rl_trends,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取运行趋势图
 * @param data
 * @returns {*|{responseURL}}
 */

export var get_yx_trends = function get_yx_trends(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.get_yx_trends,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 轨迹信息轨迹
 * @param data
 * @returns {*|{responseURL}}
 */

export var trajectory_did_detail = function trajectory_did_detail(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.trajectory_did_detail,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 协议新增
 * @param data
 * @returns {*|{responseURL}}
 */

export var protocol_add = function protocol_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.protocol_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 协议列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var protocol_list = function protocol_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.protocol_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 协议删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var protocol_del = function protocol_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.protocol_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 产品新增
 * @param data
 * @returns {*|{responseURL}}
 */

export var product_add = function product_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.product_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 产品列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var product_list = function product_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.product_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 项目密码管理
 * @param data
 * @returns {*|{responseURL}}
 */

export var config_pass = function config_pass(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.config_pass,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设备密码管理
 * @param data
 * @returns {*|{responseURL}}
 */

export var did_config_pass = function did_config_pass(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.did_config_pass,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增硬件版本号
 * @param data
 * @returns {*|{responseURL}}
 */

export var hardware_ver_add = function hardware_ver_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 硬件版本号列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var hardware_ver_list = function hardware_ver_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 产品删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var product_del = function product_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.product_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 硬件版本号编辑
 * @param data
 * @returns {*|{responseURL}}
 */

export var hardware_ver_update = function hardware_ver_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 硬件版本号删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var hardware_ver_del = function hardware_ver_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.hardware_ver_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增固件版本
 * @param data
 * @returns {*|{responseURL}}
 */

export var addfirmware = function addfirmware(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.addfirmware,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 固件版本列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var getfirmwarelist = function getfirmwarelist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.getfirmwarelist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑固件版本
 * @param data
 * @returns {*|{responseURL}}
 */

export var firmware_update = function firmware_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.firmware_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 固件版本删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var deletefirmware = function deletefirmware(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.deletefirmware,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增升级规则
 * @param data
 * @returns {*|{responseURL}}
 */

export var addfirmware_rule = function addfirmware_rule(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.addfirmware_rule,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 升级规则列表
 * @param data
 * @returns {*|{responseURL}}
 */

export var getfirmware_rulelist = function getfirmware_rulelist(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.getfirmware_rulelist,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑升级规则
 * @param data
 * @returns {*|{responseURL}}
 */

export var firmware_ruleupdate = function firmware_ruleupdate(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.firmware_ruleupdate,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 升级规则删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var deletefirmware_rule = function deletefirmware_rule(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.deletefirmware_rule,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 升级规则删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var download_file = function download_file(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.download_file,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 升级规则删除
 * @param data
 * @returns {*|{responseURL}}
 */

export var progress_firmware = function progress_firmware(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.progress_firmware,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 设备下拉相关
 * @param data
 * @returns {*|{responseURL}}
 */

export var device_about = function device_about(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.device_about,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 导出产测成功设备ID
 * @param data
 * @returns {*|{responseURL}}
 */

export var export_success_did = function export_success_did(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: jingxiaoshang.export_success_did,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};